export default __webpack_public_path__ + "backgroundSign.c4a35f9.png";